import { useMutation } from "@tanstack/react-query";
import { apiClient } from "./api-client";

export function useGetAllDiscounts() {
  return useMutation({
    mutationFn: ({ page, limit, search }) => {
      const params = new URLSearchParams();

      if (page) params.append("page", String(page));
      if (limit) params.append("limit", String(limit));
      if (search) params.append("search", search);

      const query = params.toString();

      return apiClient({
        url: `admin/discounts/all${query ? `?${query}` : ""}`,
        method: "GET"
      });
    }
  });
}

export function useCreateDiscount() {
  return useMutation({
    mutationFn: (payload) =>
      apiClient({
        url: "admin/discounts",
        method: "POST",
        data: payload
      })
  });
}

export function useUpdateDiscount() {
  return useMutation({
    mutationFn: ({ slug, ...payload }) =>
      apiClient({
        url: `admin/discounts/${slug}`,
        method: "PATCH",
        data: payload
      })
  });
}

export function useToggleDiscountStatus() {
  return useMutation({
    mutationFn: ({ slug, status }) =>
      apiClient({
        url: `admin/activate-deactivate-discount/${slug}`,
        method: "PATCH",
        data: { status }
      })
  });
}
